/** Payment methods offered by the CardConnect Payment (OMD0043) popup - Delphi rdProfile / rdCard / rdNewProfile. */
export const CardConnectPaymentMethods = Object.freeze({
    Profile: "profile",
    Card: "card",
    NewProfile: "newProfile",
});

/** Delphi btnOKClick: the -newprofile value that asks Card Connect to create a profile while paying. */
export const CARDCONNECT_NEW_PROFILE = "New";

/**
 * Form layout for CardConnect Payment (OMD0043) popup: two groups, rendered side by side by cardConnectPay.css -
 * the payment method on the left (Delphi pnlOptions) and the order's details stacked on the right (pnlFilter).
 * FormField reads the layout once, when it mounts, so the popup builds it per open.
 * @param {boolean} hasProfile - the customer already has a payment profile (Delphi FormShow): "Pay using Profile"
 *   is offered, "Create Profile and Pay" is not, and the popup opens on Profile with Account editable. Otherwise
 *   the reverse, and the popup opens on "Pay using Card".
 */
export function getCardConnectPayLayout(hasProfile) {
    return [
    {
        "groupId": 1,
        "label": "Payment Method",
        "fields": [
            {
                // The group legend names the choice, so cardConnectPay.css hides the radio's own caption.
                "name": "CARDCONNECT_PAYMENT_METHOD",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Payment method",
                "type": "radio",
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
                "options": [
                    { "value": CardConnectPaymentMethods.Profile, "text": "Pay using Profile", "disabled": !hasProfile },
                    { "value": CardConnectPaymentMethods.Card, "text": "Pay using Card" },
                    { "value": CardConnectPaymentMethods.NewProfile, "text": "Create Profile and Pay", "disabled": hasProfile },
                ],
            },
        ],
    },
    {
        "groupId": 2,
        "label": "Payment Details",
        "fields": [
            {
                "name": "CARDCONNECT_TRANS_NO",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Trans #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
            {
                "name": "CARDCONNECT_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
            {
                "name": "CARDCONNECT_AMOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Amount",
                "type": "number",
                "required": false,
                "visible": true,
                "readOnly": true,
                "format": "#,##0.00",
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
            {
                // Delphi edtProfile is always read-only: the profile id comes from the customer, never from the user.
                "name": "CARDCONNECT_PROFILE",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
            {
                // Delphi edtAccount ("Credit Card Number" hint): the account within the profile. Editable only while
                // "Pay using Profile" is selected - the popup toggles it after load when the method changes.
                "name": "CARDCONNECT_ACCOUNT",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Account",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": !hasProfile,
                "isLabelChanged": true,
                "ignoredblocalization": true,
            },
        ],
    },
];
}
